/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friendprofilebtnreport3Inputs */



/**
* | output |
* | --- |
* | "Report" |
*
* @param {Friendprofilebtnreport3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const friendprofilebtnreport3 = /** @type {((inputs?: Friendprofilebtnreport3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friendprofilebtnreport3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Report")
	if (locale === "es") return /** @type {LocalizedString} */ ("Denunciar")
	return /** @type {LocalizedString} */ ("Пожаловаться")
});
export { friendprofilebtnreport3 as "friendProfileBtnReport" }